angular.module('core')
    .directive('historyBack', function ($window) {
        return {
            restrict: 'A',
            link: function (scope, elem, attrs) {
                elem.bind('click', () => $window.history.back());
            }
        };
    })
